module.exports = __webpack_public_path__ + "img/TRANSPORTE.8ecbf12a.png";